import * as React from "react";
const sizes = {
    xs: 16,
    sm: 20,
    md: 20,
    lg: 24,
    xl: 36,
};
function SvgCash(props) {
    return (React.createElement("svg", Object.assign({ width: sizes[props.size || "lg"], height: sizes[props.size || "lg"], viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.5 4C5.93497 4 4.38388 4.3692 2.85484 5.08461C2.31876 5.33543 2 5.87095 2 6.43444V16.5681C2 17.7087 3.1712 18.3606 4.12265 17.9619C5.26001 17.4852 6.38367 17.2536 7.5 17.2536C8.96532 17.2536 10.2013 17.7373 11.6259 18.3071C13.1933 18.9342 14.783 19.5036 16.4946 19.5036C18.0598 19.5036 19.6123 19.1344 21.144 18.4192C21.6807 18.1687 22 17.6329 22 17.0689V6.9321C22 5.79476 20.8333 5.14036 19.881 5.5378C18.7305 6.01788 17.6057 6.25 16.5 6.25C15.0318 6.25 13.7957 5.76626 12.3714 5.19652C10.803 4.56904 9.21258 4 7.5 4ZM15 11.7518C15 13.4087 13.6569 14.7518 12 14.7518C10.3431 14.7518 9 13.4087 9 11.7518C9 10.095 10.3431 8.75182 12 8.75182C13.6569 8.75182 15 10.095 15 11.7518Z", fill: "currentColor" })));
}
export default SvgCash;
